import { ISelectItem } from "@/types";
import { ITag } from "@/types/tag";

export class Tag implements ITag {
  public id = 0;
  public name = "";
  public company_id = 0;
  public created_at = "";
  public updated_at = "";

  public constructor(props?: ITag) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(tag: ITag): ISelectItem {
    return {
      text: tag.name,
      value: tag.id,
    };
  }
}
